import { Injectable, inject } from '@angular/core';
import formbricks from '@formbricks/js';

import { ConfigService } from './config.service';

@Injectable({
	providedIn: 'root',
})
export class FormbricksService {
	private configService = inject(ConfigService);
	private initialized = false;

	public async init(): Promise<void> {
		if (this.initialized || typeof window === 'undefined') {
			return;
		}

		const environmentId = this.configService.formbricksEnvironmentId;
		const appUrl = this.configService.formbricksAppUrl;

		if (!environmentId || !appUrl) {
			return;
		}

		try {
			await formbricks.setup({
				environmentId,
				appUrl,
			});
			this.initialized = true;
		} catch (error) {
			console.error('Formbricks setup failed', error);
		}
	}

	public async track(
		eventName: string,
		hiddenFields?: Record<string, string | number | string[]>,
	): Promise<void> {
		if (!this.initialized) {
			return;
		}

		try {
			await formbricks.track(
				eventName,
				hiddenFields ? { hiddenFields } : undefined,
			);
		} catch (error) {
			console.error('Formbricks track failed', error);
		}
	}

	public async registerRouteChange(): Promise<void> {
		if (!this.initialized) {
			return;
		}

		try {
			await formbricks.registerRouteChange();
		} catch (error) {
			console.error('Formbricks registerRouteChange failed', error);
		}
	}

	public async logout(): Promise<void> {
		if (!this.initialized) {
			return;
		}

		try {
			await formbricks.logout();
		} catch (error) {
			console.error('Formbricks logout failed', error);
		}
	}
}
